import { type ElasticsearchQuery, type FacetFieldConfig } from '@searchkit/api';

import { lineReductionQuery, sportsDataHistoryRequiredQuery, validPlayerDataQuery } from '~/search-domain/queries';
import { type SearchDomainContext, type SearchRuntimeSortingConfig } from '~/search-domain/types';

const playerDataResultAttributes = [
  'aiProbability',
  'aiProjection',
  'betId',
  'betName',
  'betTypeId',
  'bookmakerCode',
  'categoryGroupName',
  'categoryName',
  'expectedValue',
  'expectedValueStatus',
  'line',
  'marketDisplayName',
  'marketDisplayNameMap',
  'oddsFractional',
  'oddsDecimal',
  'oddsAmerican',
  'parentBetId',
  'sportsData',
  'sportsbookProbability',
  'subeventName',
  'subeventStartTime',
  'teamData',
  'type',
];

export function getPlayerDataFacetAttributes(context: SearchDomainContext): FacetFieldConfig[] {
  const repubCountry = context.repubCountry;
  if (!repubCountry) return [];

  return [
    {
      attribute: 'sportsData.participant.participantId',
      field: 'sportsData.participant.participantId',
      type: 'string',
    },
    {
      attribute: 'marketDisplayName',
      field: `marketDisplayNameMap.${repubCountry}.keyword`,
      type: 'string',
    },
  ];
}

export function getPlayerDataBaseFilters(context: SearchDomainContext): ElasticsearchQuery[] {
  const baseFilters: ElasticsearchQuery[] = [validPlayerDataQuery, sportsDataHistoryRequiredQuery];

  if (context.searchFlags.lineReduction) {
    baseFilters.push(lineReductionQuery);
  }

  return baseFilters;
}

export function getPlayerDataSearchSettings() {
  return {
    results: playerDataResultAttributes,
    search: [],
    highlights: [],
  };
}

export function getPlayerDataSorting(): SearchRuntimeSortingConfig {
  return {
    options: [{ field: 'sportsData.participant.participantId', label: 'Participant ID', order: 'asc' }],
  };
}
